import { isAxiosError } from 'axios';
import { fetchPaymentNetworksTokens } from 'entities/payment/api';
import { actionTypes } from 'entities/payment/model/action-types';
import { actions } from 'entities/payment/model/reducer';
import { createAppAsyncThunk, logger } from 'shared';

export const getNetworks = createAppAsyncThunk(
  actionTypes.GET_PAYMENT_NETWORKS_TOKENS,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await fetchPaymentNetworksTokens();

      dispatch(actions.setPaymentAssets(data));

      return null;
    } catch (error) {
      logger(actionTypes.GET_PAYMENT_REQUEST, error);

      if (isAxiosError(error) && error.code === '404') {
        dispatch(actions.setPayment(null));
        return null;
      }

      return rejectWithValue(error);
    }
  },
);
